import { atom } from "recoil"
import { getRecoil, setRecoil } from "recoil-nexus";

// Alert State
export const isOpenAlertState = atom({
  key: 'common-is-open-alert',
  default: false,
});

export const alertMessageState = atom({
  key: 'common-alert-message',
  default: '',
});

export const alertCallbackState = atom({
  key: 'common-alert-callback',
  default: () => {},
});

// Confirm State
export const isOpenConfirmState = atom({
  key: 'common-is-open-confirm',
  default: false,
});

export const confirmMessageState = atom({
  key: 'common-confirm-message',
  default: '',
});

export const confirmConfirmActionState = atom({
  key: 'common-confirm-confirm-action',
  default: () => setRecoil(isOpenConfirmState, false),
});

export const confirmCancelActionState = atom({
  key: 'common-confirm-cancel-action',
  default: () => setRecoil(isOpenConfirmState, false),
});

export const confirmConfirmTextState = atom({
  key: 'common-confirm-confirm-text',
  default: '',
});

export const confirmCancelTextState = atom({
  key: 'common-confirm-cancel-text',
  default: '',
});

// Selectbox State
export const isOpenSelectboxState = atom({
  key: 'common-is-open-selectbox',
  default: false,
});

export const selectboxMessageState = atom({
  key: 'common-selectbox-message',
  default: '',
});

export const selectboxSelectTextState = atom({
  key: 'common-selectbox-select-texts',
  default: [''],
});

export const selectboxSelectActionState = atom({
  key: 'common-selectbox-select-actions',
  default: [() => setRecoil(isOpenConfirmState, false)],
});

export const selectboxCancelTextState = atom({
  key: 'common-selectbox-cancel-text',
  default: '',
});

export const selectboxCancelActionState = atom({
  key: 'common-selectbox-cancel-action',
  default: () => setRecoil(isOpenConfirmState, false),
});

// Inputbox State
export const isOpenInputboxState = atom({
  key: 'common-is-open-inputbox',
  default: false,
});

export const inputboxMessageState = atom({
  key: 'common-inputbox-message',
  default: '',
});

export const inputboxInputState = atom({
  key: 'common-inputbox-input',
  default: '',
});

export const inputboxConfirmActionState = atom({
  key: 'common-inputbox-confirm-action',
  default: () => setRecoil(isOpenConfirmState, false),
});

export const inputboxCancelActionState = atom({
  key: 'common-inputbox-cancel-action',
  default: () => setRecoil(isOpenConfirmState, false),
});

export const inputboxConfirmTextState = atom({
  key: 'common-inputbox-confirm-text',
  default: '',
});

export const inputboxCancelTextState = atom({
  key: 'common-inputbox-cancel-text',
  default: '',
});

export const openAlert = (message: string, callback: () => void = () => {}) => {
  setRecoil(alertMessageState, message);
  setRecoil(alertCallbackState, () => callback);
  setRecoil(isOpenAlertState, true);
};

export const openConfirm = (
  message: string,
  confirmAction: () => void,
  cancelAction: () => void = () => {},
  confirmText: string = '확인',
  cancelText: string = '취소',
) => {
  setRecoil(confirmMessageState, message);
  setRecoil(confirmConfirmActionState, () => () => { confirmAction(); setRecoil(isOpenConfirmState, false); });
  setRecoil(confirmCancelActionState, () => () => { cancelAction(); setRecoil(isOpenConfirmState, false); });
  setRecoil(confirmConfirmTextState, confirmText);
  setRecoil(confirmCancelTextState, cancelText);
  setRecoil(isOpenConfirmState, true);
};

export const openSelectbox = (
  message: string,
  selectTexts: string[],
  selectActions: (() => void)[],
  cancelText: string = '취소',
  cancelAction: () => void = () => {},
) => {
  setRecoil(selectboxMessageState, message);
  setRecoil(selectboxSelectActionState, selectActions.map((selectAction) => () => { selectAction(); setRecoil(isOpenSelectboxState, false); }));
  setRecoil(selectboxCancelActionState, () => () => { cancelAction(); setRecoil(isOpenSelectboxState, false); });
  setRecoil(selectboxSelectTextState, selectTexts);
  setRecoil(selectboxCancelTextState, cancelText);
  setRecoil(isOpenSelectboxState, true);
};

export const openInputbox = (
  message: string,
  confirmAction: (input: string) => void,
  cancelAction: () => void = () => {},
  confirmText: string = '확인',
  cancelText: string = '취소',
) => {
  setRecoil(inputboxMessageState, message);
  setRecoil(inputboxInputState, '');
  setRecoil(inputboxConfirmActionState, () => () => { confirmAction(getRecoil(inputboxInputState)); setRecoil(isOpenInputboxState, false); });
  setRecoil(inputboxCancelActionState, () => () => { cancelAction(); setRecoil(isOpenInputboxState, false); });
  setRecoil(inputboxConfirmTextState, confirmText);
  setRecoil(inputboxCancelTextState, cancelText);
  setRecoil(isOpenInputboxState, true);
};


export const userBoxState = atom({
  key: 'user-box',
  default: {
    display: false,
    x: 0,
    y: 0,
    userId: '',
    userName: '',
  },
});
